import { type PropsWithChildren, type ReactElement } from 'react';

import { valueContent } from './MeterBarTooltipItem.sty.js';
import { TooltipPointIndicator } from '../../../../../core/components/tooltip/section-components/atoms/TooltipPointIndicator.js';
import { TooltipText } from '../../../../../core/components/tooltip/section-components/atoms/TooltipText.js';
import { TooltipInfoContent } from '../../../../../core/components/tooltip/section-components/TooltipInfoContent/TooltipInfoContent.js';
import { TooltipItem } from '../../../../../core/components/tooltip/section-components/TooltipItem/TooltipItem.js';
import { TooltipSymbolContent } from '../../../../../core/components/tooltip/section-components/TooltipSymbolContent/TooltipSymbolContent.js';
import { TooltipValueContent } from '../../../../../core/components/tooltip/section-components/TooltipValueContent/TooltipValueContent.js';
import { SeriesActionsTemplate } from '../../../../../core/types/series-actions-template.js';
import { TooltipItem as TooltipItemType } from '../../../../../core/types/tooltip.js';
import { getValidColor } from '../../../../../core/utils/getValidColor.js';

interface MeterBarTooltipItemProps {
  item: TooltipItemType;
  activeItem?: boolean;
  showDivider?: boolean;
  actions?: () => SeriesActionsTemplate;
  defaultActions?: ReactElement<PropsWithChildren>;
}

export const MeterBarTooltipItem = (props: MeterBarTooltipItemProps) => {
  const { item, actions, activeItem, showDivider, defaultActions } = props;

  return (
    <TooltipItem
      actions={actions}
      defaultActions={defaultActions}
      showDivider={showDivider}
      data-testid="chart-tooltip-item"
    >
      {item.color && (
        <TooltipSymbolContent>
          <TooltipPointIndicator
            color={getValidColor(item.color.Default)}
            active={activeItem}
          />
        </TooltipSymbolContent>
      )}
      <TooltipInfoContent>
        <TooltipText>{item.name as string}</TooltipText>
      </TooltipInfoContent>
      {item.values && (
        <TooltipValueContent variant="chip" className={valueContent}>
          {item.values[0]}
        </TooltipValueContent>
      )}
    </TooltipItem>
  );
};

MeterBarTooltipItem['displayName'] = 'MeterBarTooltipItem';
